<template>
    <div v-if="imageFile">
        <div
            :class="
                'group relative rounded bg-cover bg-center bg-no-repeat' +
                ' ' +
                imagePreviewCss +
                ' '
            "
            :style="'background-image: url(' + imageFile + ')'"
        >
            <div
                class="invisible absolute bottom-0 flex w-full group-hover:visible"
            >
                <span
                    class="flex-grow rounded-br bg-black/75 px-2 py-1 text-center text-[14px] font-medium text-white hover:cursor-pointer hover:bg-white hover:text-black"
                    @click="remove()"
                    title="Remove"
                >
                    Remove
                </span>
            </div>
        </div>
    </div>
    <div
        v-else
        :class="imagePreviewCss"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
        class="rounded"
    >
        <input
            type="file"
            name="imageFileUpload"
            id="image_file_upload"
            class="absolute h-px w-px overflow-hidden opacity-0"
            @change="onChange"
            ref="file"
            accept=".jpg,.jpeg,.png"
        />

        <label
            for="image_file_upload"
            class="block flex h-full w-full cursor-pointer items-center justify-center rounded"
        >
            <div v-if="$slots.default" class="p-4 font-semibold text-gray-600">
                <slot />
            </div>
            <div v-else class="p-4 font-semibold text-gray-600">
                <div class="text-center">
                    Click here or drag an image to upload
                </div>
            </div>
        </label>
    </div>
</template>
<script>
export default {
    name: "DragImageUploadField",
    props: {
        modelValue: {
            type: String,
            default: null,
        },
        imagePreviewCss: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            imageUpload: null,
            imageFile: null,
        };
    },
    methods: {
        onChange() {
            let vm = this;
            let reader = new FileReader();

            vm.imageUpload = vm.$refs.file.files[0];

            reader.readAsDataURL(vm.imageUpload);

            reader.onloadend = function () {
                vm.imageFile = reader.result;
                vm.$emit("update:modelValue", vm.imageFile);
            };
        },
        remove() {
            this.imageUpload = null;
            this.imageFile = null;
            this.$emit("update:modelValue", null);
        },
        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains("bg-green-300")) {
                event.currentTarget.classList.remove("bg-gray-100");
                event.currentTarget.classList.add("bg-green-300");
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange(); // Trigger the onChange event manually
            // Clean up
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
        },
    },
};
</script>
